import React from 'react';
import { X } from 'lucide-react';
import { cn } from './cn';

/**
 * Badge / chip trạng thái. Status dùng thang Tailwind (emerald/red/amber), brand dùng token.
 * variant: neutral | brand | success | danger | warning | info | dark
 * size: 'sm' (mặc định, 12px) | 'lg' (14px) · pill: bo tròn full · dot: chấm màu phía trước
 */
const VARIANTS = {
  neutral:
    'bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700',
  brand: 'bg-brand-softer text-brand-fg-strong border-transparent',
  success:
    'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-900',
  danger:
    'bg-red-50 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-900',
  warning:
    'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900',
  info:
    'bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950 dark:text-indigo-300 dark:border-indigo-900',
  dark: 'bg-gray-900 text-white border-transparent dark:bg-gray-700',
};

const DOT_COLOR = {
  neutral: 'bg-gray-400',
  brand: 'bg-brand',
  success: 'bg-emerald-500',
  danger: 'bg-red-500',
  warning: 'bg-amber-500',
  info: 'bg-indigo-500',
  dark: 'bg-gray-500',
};

export function Badge({
  variant = 'neutral',
  size = 'sm',
  pill = false,
  dot = false,
  leftIcon: LeftIcon,
  onDismiss,
  className,
  children,
  ...props
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 border font-medium whitespace-nowrap',
        size === 'lg' ? 'text-sm px-2 py-1' : 'text-xs px-1.5 py-0.5',
        pill ? 'rounded-full' : 'rounded-lg',
        VARIANTS[variant] || VARIANTS.neutral,
        className
      )}
      {...props}
    >
      {dot ? <span className={cn('w-1.5 h-1.5 rounded-full', DOT_COLOR[variant])} aria-hidden="true" /> : null}
      {LeftIcon ? <LeftIcon className={size === 'lg' ? 'w-3.5 h-3.5' : 'w-3 h-3'} aria-hidden="true" /> : null}
      {children}
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Bỏ chọn"
          className="ml-0.5 -mr-0.5 rounded p-0.5 hover:bg-black/10 dark:hover:bg-white/10"
        >
          <X className="w-3 h-3" />
        </button>
      ) : null}
    </span>
  );
}

export default Badge;
